<template lang="html">
  <div class="px-6">
    <v-card-title primary-title class="card-header mx-0 px-0 py-2">
      <span v-if="acao.idContrato">{{ $tc('label.contrato', 1)}} :: {{ acao.idContrato }} :: {{ acao.divisao }} :: {{ acao.idAcao }} - {{ acao.idApuracao }} :: {{ acao.tipoAcao }}</span>
      <span v-else>{{ $t('label.apuracao_acao_detalhes_resumo', { ...acao }) }}</span>
      <popover-lista id="popover_acao" :objeto="acaoFormatada" :campos="listaPopover()"/>

      <v-chip v-if="acaoFormatada.status"
        :color="chipStatusColor"
        text-color="white">
        {{acaoFormatada.status}}
      </v-chip>
    </v-card-title>
    <div class="d-flex justify-end align-center flex-shrink-0 pb-2">
      <slot name="depoisTitulo"></slot>
    </div>

    <div class="body-1 mx-0 pb-2">
      <div v-if="camposContratoProduto">{{ camposContratoProduto }}</div>
      <div v-if="exibirCampoContrato('descricao') && exibirCampo('descricao')">
        <div v-if="acao.descricaoContrato">{{ `${$t('label.descricao_contrato')}: ${acao.descricaoContrato}` }}</div>
        <div v-if="acao.descricao">{{ `${$t('label.descricao_acao')}: ${acao.descricao}` }}</div>
      </div>
      <div v-else-if="exibirCampoContrato('descricao') && acao.descricaoContrato">{{ acao.descricaoContrato }}</div>
      <div v-else-if="exibirCampo('descricao') && acao.descricao">{{ acao.descricao }}</div>
      <div>{{ `${$t('label.periodo_apuracao')}: ${acao.dtaInicioApuracao} ${$tc('label.a', 2)} ${acao.dtaFimApuracao}` }}</div>
      <div v-if="exibirCampo('periodo_planejamento')">{{ `${$t('label.periodo_planejamento')}: ${acao.dtaInicio} ${$tc('label.a', 2)} ${acao.dtaFim}` }}</div>
      <div v-if="exibirCampo('periodo')">{{ `${$t('label.periodo_planejamento')}: ${acao.dtaInicio} ${$tc('label.a', 2)} ${acao.dtaFim}` }}</div>
      <div v-if="acao.regiao">{{ `Região: ${acao.regiao}` }}</div>
      <div>{{ `${$tc('label.responsavel', 1)}: ${acao.responsaveis}` }}</div>
      <div v-if="exibirJustificativaCancelamentoFluxo">{{ $t('message.justificativa_cancelamento_acao', { usuario: acao.usuarioAprovador, justificativa: acao.justificativaApuracao}) }}</div>
      <div v-if="exibirJustificativaCancelamentoApuracao">{{ $t('message.justificativa_cancelamento_acao_data', { data: formatDatePattern(acao.dtaCancelamento, 'YYYY-MM-DD'), hora: acao.horaCancelamento, usuario: acao.usuarioCancelamento, justificativa: acao.justificativaCancelamento}) }}</div>

      <div v-if="acao.dadosResgate != null">
        {{ $t('message.apuracao_resgatada_informacao', { ...JSON.parse(acao.dadosResgate.value) }) }}
      </div>
      <div v-if="acao.dadosResgate != null">
        {{ `${$t('label.data_prorrogacao')}: ${JSON.parse(acao.dadosResgate.value).dta_prorrogacao}`}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PopoverLista from '../../shared-components/PopoverLista';
import { formatDatePattern } from '../../common/functions/date-utils';

export default {
  components: {
    PopoverLista,
  },
  props: {
    acao: Object,
    configuracao: Object,
    configuracaoContrato: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      metadadoResource: this.$api.metadado(this.$resource),
      acaoFormatada: {},
      exibirJustificativaCancelamentoFluxo: false,
    };
  },
  computed: {
    ...mapGetters('metadados', [
      'getAcaoMetadado',
      'getContratoMetadado',
    ]),
    camposContratoProduto() {
      if (this.configuracaoContrato.passo2) {
        const { listaProduto } = this.configuracaoContrato.passo2;
        return listaProduto
          .filter((p) => p.fluxos.includes('APURACAO') && this.valorCampoProduto(p.label))
          .map((p) => this.valorCampoProduto(p.label))
          .join(' / ');
      }
      return '';
    },
    exibirJustificativaCancelamentoApuracao() {
      return this.acao.statusApuracao === 'CANCELADO'
          && this.acao.justificativaCancelamento && this.acao.usuarioCancelamento;
    },
    chipStatusColor() {
      const { statusApuracao } = this.acaoFormatada;
      switch ((statusApuracao || '')) {
        case 'APURACAO_PREVIA': {
          return 'rgb(149, 165, 166)';
        }
        case 'AGUARDANDO_APURACAO': {
          return 'rgb(30, 136, 229)';
        }
        case 'AGUARDANDO_APROVACAO': {
          return 'rgb(230, 126, 34)';
        }
        case 'EM_ANALISE': {
          return 'rgb(241, 196, 15)';
        }
        case 'APROVADO': {
          return 'rgb(26, 188, 156)';
        }
        case 'REPROVADO': {
          return 'rgb(231, 76, 60)';
        }
        case 'CANCELADO': {
          return 'rgb(126, 87, 194)';
        }
        case 'VENCIDO': {
          return 'rgb(107, 35, 142)';
        }
        default: {
          return 'grey';
        }
      }
    },
  },
  methods: {
    formatDatePattern,
    ...mapActions('metadados', [
      'setAcaoMetadado',
      'setContratoMetadado',
    ]),
    valorCampoProduto(campo) {
      return this.acao[campo]
          && this.acao[campo].nomExtensao
        ? this.acao[campo].nomExtensao
        : this.acao[campo];
    },
    exibirCampo(campo) {
      if (this.configuracao.passo3) {
        const { listaPadrao } = this.configuracao.passo3;
        return !!listaPadrao.filter((p) => p.fluxos.includes('APURACAO') && p.label === campo).length;
      }
      return false;
    },
    exibirCampoContrato(campo) {
      if (this.configuracaoContrato.passo2) {
        const { listaPadrao } = this.configuracaoContrato.passo2;
        return !!listaPadrao.filter((p) => p.fluxos.includes('APURACAO') && p.label === campo).length;
      }
      return false;
    },
    listaPopover() {
      const lista = [];
      if (this.exibirCampo('unidadenegocio')) {
        lista.push({ campo: 'unidadeNegocio', label: this.$tc('label.unidade_negocio', 1) });
      }

      if (this.configuracao.passo3) {
        const { listaDinamica } = this.configuracao.passo3;
        const camposApuracao = listaDinamica.filter((p) => p.fluxos.includes('APURACAO'));
        camposApuracao.forEach((a) => lista.push({
          campo: a.label,
          label: this.montaLabelCampoDinamico(a.label),
        }));
      }

      if (this.configuracaoContrato.passo2) {
        const { listaDinamica } = this.configuracaoContrato.passo2;
        const camposApuracao = listaDinamica.filter((p) => p.fluxos.includes('APURACAO'));
        camposApuracao.forEach((a) => lista.push({
          campo: a.label,
          label: this.montaLabelCampoDinamicoContrato(a.label),
        }));
      }

      return lista.filter((x) => !(this.acaoFormatada[x.campo] === null
          || this.acaoFormatada[x.campo] === ''
          || this.acaoFormatada[x.campo] === undefined));
    },
    formatarObjeto() {
      this.acaoFormatada = { ...this.acao };
      if (this.acao && this.acao.statusApuracao) {
        this.acaoFormatada.status = this.$tc(`status_entidade.${this.acao.statusApuracao.toLowerCase()}`, 1);
      }
      if (this.acaoFormatada) {
        this.exibirJustificativaCancelamentoFluxo = this.acaoFormatada.statusFluxo === 'CANCELADO'
            && this.acaoFormatada.justificativaApuracao && this.acaoFormatada.usuarioAprovador;
      }
    },
    montaLabelCampoDinamico(campo) {
      const metadado = this.getAcaoMetadado.mapaCamposDinamicos;
      return (metadado[campo] || {}).nomCampo;
    },
    montaLabelCampoDinamicoContrato(campo) {
      const metadado = this.getContratoMetadado.mapaCamposDinamicos;
      return (metadado[campo] || {}).nomCampo;
    },
  },
  beforeMount() {
    this.setAcaoMetadado({
      resource: this.metadadoResource.definicaoAcao,
    });
    this.setContratoMetadado({
      resource: this.metadadoResource.definicaoContrato,
    });
  },
};
</script>
